import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const transactionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactionHistoryV2: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, `/api/transaction/history/v2`),
      }),
      providesTags: ["Transaction-History"],
    }),
    verifyTransaction: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/transaction/verify/${id}`,
        method: "PATCH",
        body: null,
      }),
      invalidatesTags: ["Transaction-History"],
    }),
    toggleRefundStatus: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/transaction/toggle-refund-status/${id}`,
        method: "PATCH",
        body: null,
      }),
      invalidatesTags: ["Transaction-History"],
    }),
  }),
});

export const {
  useGetTransactionHistoryV2Query,
  useVerifyTransactionMutation,
  useToggleRefundStatusMutation,
} = transactionApi;
